import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { objectify } from './array.mjs';
import { toInt } from './number.mjs';
import { isPrimitive, isObject, isArray } from './typed.mjs';
var shake = function shake(obj) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x === void 0;
  };
  if (!obj) return {};
  var keys2 = Object.keys(obj);
  return keys2.reduce(function (acc, key) {
    if (filter(obj[key])) {
      return acc;
    } else {
      acc[key] = obj[key];
      return acc;
    }
  }, {});
};
var mapKeys = function mapKeys(obj, mapFunc) {
  var keys2 = Object.keys(obj);
  return keys2.reduce(function (acc, key) {
    acc[mapFunc(key, obj[key])] = obj[key];
    return acc;
  }, {});
};
var mapValues = function mapValues(obj, mapFunc) {
  var keys2 = Object.keys(obj);
  return keys2.reduce(function (acc, key) {
    acc[key] = mapFunc(obj[key], key);
    return acc;
  }, {});
};
var mapEntries = function mapEntries(obj, toEntry) {
  if (!obj) return {};
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var _toEntry = toEntry(key, value),
      _toEntry2 = _slicedToArray(_toEntry, 2),
      newKey = _toEntry2[0],
      newValue = _toEntry2[1];
    acc[newKey] = newValue;
    return acc;
  }, {});
};
var invert = function invert(obj) {
  if (!obj) return {};
  var keys2 = Object.keys(obj);
  return keys2.reduce(function (acc, key) {
    acc[obj[key]] = key;
    return acc;
  }, {});
};
var lowerize = function lowerize(obj) {
  return mapKeys(obj, function (k) {
    return k.toLowerCase();
  });
};
var upperize = function upperize(obj) {
  return mapKeys(obj, function (k) {
    return k.toUpperCase();
  });
};
var clone = function clone(obj) {
  if (isPrimitive(obj)) {
    return obj;
  }
  if (typeof obj === "function") {
    return obj.bind({});
  }
  var newObj = new obj.constructor();
  Object.getOwnPropertyNames(obj).forEach(function (prop) {
    newObj[prop] = obj[prop];
  });
  return newObj;
};
var listify = function listify(obj, toItem) {
  if (!obj) return [];
  var entries = Object.entries(obj);
  if (entries.length === 0) return [];
  return entries.reduce(function (acc, entry) {
    acc.push(toItem(entry[0], entry[1]));
    return acc;
  }, []);
};
var pick = function pick(obj, keys2) {
  if (!obj) return {};
  return keys2.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) acc[key] = obj[key];
    return acc;
  }, {});
};
var omit = function omit(obj, keys2) {
  if (!obj) return {};
  if (!keys2 || keys2.length === 0) return obj;
  return keys2.reduce(function (acc, key) {
    delete acc[key];
    return acc;
  }, _objectSpread({}, obj));
};
var get = function get(value, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var segments = path.split(/[\.\[\]]/g);
  var current = value;
  var _iterator = _createForOfIteratorHelper(segments),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (current === null) return defaultValue;
      if (current === void 0) return defaultValue;
      if (key.trim() === "") continue;
      current = current[key];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (current === void 0) return defaultValue;
  return current;
};
var set = function set(initial, path, value) {
  if (!initial) return {};
  if (!path || !value) return initial;
  var segments = path.split(/[\.\[\]]/g).filter(function (x) {
    return !!x.trim();
  });
  var _set = function _set(node) {
    if (segments.length > 1) {
      var key = segments.shift();
      var nextIsNum = toInt(segments[0], null) === null ? false : true;
      node[key] = node[key] === void 0 ? nextIsNum ? [] : {} : node[key];
      _set(node[key]);
    } else {
      node[segments[0]] = value;
    }
  };
  var cloned = clone(initial);
  _set(cloned);
  return cloned;
};
var assign = function assign(initial, override) {
  if (!initial && !override) return {};
  if (!initial) return override;
  if (!override) return initial;
  return Object.entries(initial).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, function () {
      if (isObject(value)) return assign(value, override[key]);
      return override[key];
    }()));
  }, {});
};
var keys = function keys(value) {
  if (!value) return [];
  var getKeys = function getKeys(nested, paths) {
    if (isObject(nested)) {
      return Object.entries(nested).flatMap(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          k = _ref6[0],
          v = _ref6[1];
        return getKeys(v, [].concat(_toConsumableArray(paths), [k]));
      });
    }
    if (isArray(nested)) {
      return nested.flatMap(function (item, i) {
        return getKeys(item, [].concat(_toConsumableArray(paths), ["".concat(i)]));
      });
    }
    return [paths.join(".")];
  };
  return getKeys(value, []);
};
var crush = function crush(value) {
  if (!value) return {};
  return objectify(keys(value), function (k) {
    return k;
  }, function (k) {
    return get(value, k);
  });
};
var construct = function construct(obj) {
  if (!obj) return {};
  return Object.keys(obj).reduce(function (acc, path) {
    return set(acc, path, obj[path]);
  }, {});
};
export { assign, clone, construct, crush, get, invert, keys, listify, lowerize, mapEntries, mapKeys, mapValues, omit, pick, set, shake, upperize };